<template>
    <div class="Trading">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="trading_container1 padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>交易概况</p>
                <div class="search_box">
                    <div>
                        <el-select v-model="dateOptionValue1" placeholder="自然天">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div v-show="dateOptionValue1 === 1">
                        <el-date-picker :clearable="false" v-model="dateValue1" align="left" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
                    </div>
                    <div v-show="dateOptionValue1 === 2">
                        <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="dateValue1" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周"></el-date-picker>
                    </div>
                    <div v-show="dateOptionValue1 === 3">
                        <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="dateValue1" align="left" type="month" placeholder="选择月"></el-date-picker>
                    </div>
                    <div v-show="dateOptionValue1 === 4">
                        <el-date-picker
                            :picker-options="disabledDatePickerOptions"
                            :clearable="false"
                            format="yyyy-MM-dd"
                            v-model="periodTime"
                            align="left"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div style="width: auto;">
                        <el-button type="primary" @click="TradingSituationSearch" plain>搜索</el-button>
                    </div>
                    <p @click="tradingSituationExport"><img :src="reportIcon" alt="">导出</p>
                </div>
            </div>
            <div class="state_warp">
                <div class="state_list_warp">
                    <div>
                        <p>
                            <span>访客数</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，全店各页面的访问人数，同一访客多次访问会进行去重</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[0].visitClientCount}}&emsp;- -</p>
                    </div>
                </div>
                <div class="state_list_warp">
                    <div>
                        <p>
                            <span>下单买家数</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，点击商品购买页订阅按钮的用户数，点击一次购买按钮就会发起一次下单，一人多次下单记为一人</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[1].orderCreateCustomer}}&emsp;- -</p>
                    </div>
                    <div>
                        <p>
                            <span>下单金额</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，发起的订单金额之和（用户点击订购按钮为下单，下单后会生成一个待支付订单，下单后会进入付款流程</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[2].ordercreatmoney}}&emsp;- -</p>
                    </div>
                </div>
                <div class="state_list_warp">
                    <div>
                        <p>
                            <span>支付买家数</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，付款成功的用户数，一个人多次付款记为一个（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[3].orderpaycustomer}}&emsp;- -</p>
                    </div>
                    <div>
                        <p>
                            <span>支付金额</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，所有付款订单金额之和（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[4].orderpaymoney}}&emsp;- -</p>
                    </div>
                    <div>
                        <p>
                            <span>客单价</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">筛选时间内，付款金额/付费用户数</div>
                                <img class="tooltip_icon" :src="toolIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{tradingDatas[5].customerprice}}&emsp;- -</p>
                    </div>
                </div>
                <div class="state_pic_warp">
                    <div class="pic_box">
                        <div class="fw_xdzhl_box">
                            <p>访问-下单转化率</p>
                            <p>{{tradingDatas[5].accessorderconversionrate}}</p>
                        </div>
                        <div class="xd_fkzhl_box">
                            <p>下单-付款转化率</p>
                            <p>{{tradingDatas[5].accesspaymentconversionrate}}</p>
                        </div>
                        <div class="fw_fkzhl_box">
                            <p>访问-付款转化率</p>
                            <p>{{tradingDatas[5].orderpaymentconversionrate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="echarts_line_warp">
                <TradingEchartsLine :tradingDatas="tradingDatas"></TradingEchartsLine>
            </div>
        </div>
        <div class="trading_container2 padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>交易构成</p>
                <div class="search_box">
                    <div>
                        <el-select v-model="dateOptionValue2" placeholder="自然月">
                            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <el-date-picker :picker-options="disabledDatePickerOptions" :clearable="false" v-model="dateValue2" align="left" type="month" placeholder="选择月" format="yyyy-MM"></el-date-picker>
                    </div>
                    <div style="width: auto;">
                        <el-button type="primary" @click="TradingASearch" plain>搜索</el-button>
                    </div>
                    <p @click="tradingExport"><img :src="reportIcon" alt="">导出</p>
                </div>
            </div>
            <div class="top_warp">
                <div class="echarts_pie_warp">
                    <TradingEchartsPie :tableData="tableData"></TradingEchartsPie>
                </div>
                <div class="table_warp">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="paymoney" label="付款金额(元)" align='center'></el-table-column>
                        <el-table-column prop="paymoneygrowthrate" label="较前一月涨幅" align='center'></el-table-column>
                        <el-table-column prop="PayingUsers" label="用户数" align='center'></el-table-column>
                        <el-table-column prop="payusersgrowthrate" label="较前一月涨幅" align='center'></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="echarts_bar_warp">
                <TradingEchartsBar :echartsBarData="echartsBarData"></TradingEchartsBar>
            </div>
        </div>
    </div>
</template>

<script>
import TradingEchartsLine from 'views/dataCenter/dataTabs/echarts/TradingEchartsLine'
import TradingEchartsPie from 'views/dataCenter/dataTabs/echarts/TradingEchartsPie'
import TradingEchartsBar from 'views/dataCenter/dataTabs/echarts/TradingEchartsBar'
import {getTradingData, getTradingBarChart, getTrading, getTradingSituationExport, getTradingExport} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'Trading',
    data() {
        return {
            activeIndex: '3',
            tradingDatas: [
                {
                    visitClientCount: 1,
                    visitClientYdata: []
                },
                {
                    orderCreateCustomer: 0,
                    orderCreateCustomerYdata: []
                },
                {
                    ordercreatmoney: 0,
                    orderCreatMoneyYdata: []
                },
                {
                    orderpaycustomer: 0,
                    orderPayCustomerYdata: []
                },
                {
                    orderpaymoney: 0,
                    orderPayMoneyYdata: []
                },
                {
                    accessorderconversionrate: '0.00%',
                    accesspaymentconversionrate: '0.00%',
                    orderpaymentconversionrate: '0.00%',
                    customerpriceYdata: [],
                    customerprice: 0,
                    xdisplaydata: []
                }
            ],
            echartsBarData: {},
            dateValue1: '', // 交易概况默认时间
            periodTime: '',
            dateValue2: '', // 交易构成默认时间
            reportIcon: require('@/common/images/other/data_center_report_icon@2x.png'),
            toolIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
            tableData: [],
            options: [
                {
                    value: 1,
                    label: '自然天'
                },
                {
                    value: 2,
                    label: '自然周'
                },
                {
                    value: 3,
                    label: '自然月'
                },
                {
                    value: 4,
                    label: '自定义'
                }
            ], // 交易概况选项
            dateOptionValue1: 1,
            options2: [
                {
                    value: 3,
                    label: '自然月'
                }
            ], // 交易构成选项
            dateOptionValue2: 3,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }
                ]
            },
            disabledDatePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                }
            }
        }
    },
    mounted() {
        this.findTradingData()
        this.findTradingBarChart(this.getDateTime(0))
        this.findTrading(this.getDateTime(0))
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        getWeek(value) {
            // 按周日为一周的最后一天计算
            var date = value
            // 今天是这周的第几天
            var today = date.getDay()
            // 上周日距离今天的天数（负数表示）
            var stepSunDay = -today + 1
            // 如果今天是周日
            if (today === 0) {
                stepSunDay = -7
            }
            // 周一距离今天的天数（负数表示）
            var stepMonday = 7 - today
            var time = date.getTime()
            var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
            var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
            // 本周一的日期 （起始日期）
            var startDate = this.transferDate(monday) // 日期变换
            // 本周日的日期 （结束日期）
            var endDate = this.transferDate(sunday) // 日期变换
            return [startDate, endDate]
        },
        getMonth(value) {
            // 获取当前月的第一天
            var start = value
            start.setDate(1)
            // 获取当前月的最后一天
            var date = value
            var currentMonth = date.getMonth()
            var nextMonth = ++currentMonth
            var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
            var oneDay = 1000 * 60 * 60 * 24
            var end = new Date(nextMonthFirstDay - oneDay)
            var startDate = this.transferDate(start) // 日期变换
            var endDate = this.transferDate(end) // 日期变换
            return [startDate, endDate]
        },
        transferDate(date) {
            // 年
            var year = date.getFullYear()
            // 月
            var month = date.getMonth() + 1
            // 日
            var day = date.getDate()
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            var dateString = year + '-' + month + '-' + day
            return dateString
        },
        // 交易概况导出
        tradingSituationExport() {
            if (this.dateOptionValue1 === 1 || this.dateOptionValue1 === 2 || this.dateOptionValue1 === 3) {
                if (this.dateValue1 === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.dateOptionValue1 === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.dateOptionValue1 === 1) {
                params = {
                    beginTime: this.transferDate(this.dateValue1),
                    endTime: this.transferDate(this.dateValue1)
                }
            } else if (this.dateOptionValue1 === 2) {
                params = {
                    beginTime: this.getWeek(this.dateValue1)[0],
                    endTime: this.getWeek(this.dateValue1)[1]
                }
            } else if (this.dateOptionValue1 === 3) {
                params = {
                    beginTime: this.getMonth(this.dateValue1)[0],
                    endTime: this.getMonth(this.dateValue1)[1]
                }
            } else if (this.dateOptionValue1 === 4) {
                params = {
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            getTradingSituationExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '交易概况' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 交易构成导出
        tradingExport() {
            if (this.dateValue2 === '') {
                this.$message.error(`请选择导出日期！`)
                return
            }
            this.setLoading(true)
            var params = {
                beginTime: this.getMonth(this.dateValue2)[0],
                endTime: this.getMonth(this.dateValue2)[1]
            }
            getTradingExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '交易构成' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 交易概况搜索
        TradingSituationSearch() {
            if (this.dateOptionValue1 === 1 || this.dateOptionValue1 === 2 || this.dateOptionValue1 === 3) {
                if (this.dateValue1 === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            if (this.dateOptionValue1 === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            var params = {
                timeFormat: this.dateOptionValue1 === '自然天' ? 1 : this.dateOptionValue1,
                beginTime: this.transferDate(this.dateValue1)
            }
            if (this.dateOptionValue1 === 4) {
                params = {
                    timeFormat: this.dateOptionValue1 === '自然天' ? 1 : this.dateOptionValue1,
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            getTradingData({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tradingDatas = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--交易概况Data
        findTradingData() {
            this.setLoading(true)
            var params = {
                timeFormat: 1,
                beginTime: this.getDateTime(0)
            }
            getTradingData({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tradingDatas = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 交易构成搜索
        TradingASearch() {
            if (this.dateValue2 === '') {
                this.$message.error(`请选择搜索月份！`)
                return
            }
            this.findTrading(this.transferDate(this.dateValue2))
            this.findTradingBarChart(this.dateValue2)
        },
        // 获取--交易构成Data
        findTrading(time) {
            this.setLoading(true)
            var params = {
                beginTime: time
            }
            getTrading({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data
                    this.tableData[0].name = '老付费用户'
                    this.tableData[1].name = '新付费用户'
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--交易构成柱状图
        findTradingBarChart(time) {
            this.setLoading(true)
            var params = {
                beginTime: time
            }
            getTradingBarChart({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.echartsBarData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        // 获取本月/上一个月 自然天前上一周日期
        getDateMonthTime(type) {
            var time = (new Date()).getTime() - 7 * 24 * 60 * 60 * 1000
            var dateTime = new Date(time)
            var year = dateTime.getFullYear()
            var month = null
            if (type === 1) {
                month = dateTime.getMonth() + 1
            }
            if (type === 0) {
                month = dateTime.getMonth()
            }
            if (month === 0) {
                month = 12
                year = year - 1
            }
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        TradingEchartsLine,
        TradingEchartsPie,
        TradingEchartsBar
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Trading {
    font-family:PingFangSC-Medium;
    .title_warp {
        padding: 0 20px 0 10px;
        margin-bottom: 20px;
        height: 50px;
        background-color: #F5F7FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &>p {
            border-left: 2px solid #409EFF;
            padding-left: 8px;
            color: #303133;
        }
        .search_box{
            display: flex;
            align-items: center;
            .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 0;
                height: 36px;
            }
            .el-button {
                height: 36px;
            }
            &>div{
                height: 36px;
                vertical-align: middle;
                margin-right: 20px;
                .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                    width: 240px;
                }
                .el-date-editor .el-range-separator {
                    line-height: 28px;
                }
            }
            &>div:nth-of-type(1){
                width: 100px;
            }
            &>p {
                color: #409EFF;
                cursor: pointer;
                img{
                    width: 16px;
                    height: 14px;
                    margin-right: 8px;
                }
            }
        }
    }
    .trading_container1 {
        margin-bottom: 20px;
        .state_warp{
            position: relative;
            color: #606266;
            .state_list_warp{
                height: 120px;
                background: rgba(42, 117, 237, 0.06);
                display: flex;
                &>div {
                    padding-left: 40px;
                    width: 188px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    &>p{
                        height: 20px;
                        line-height: 20px;
                        display: flex;
                        align-items: center;
                        &>img {
                            width: 13px;
                            height: 13px;
                            cursor: pointer;
                            margin-left: 10px;
                        }
                    }
                    &>p:nth-of-type(2){
                        height: 22px;
                        line-height: 22px;
                        font-size:16px;
                        font-weight:500;
                    }
                }
            }
            .state_list_warp:nth-of-type(2){
                background: rgba(42, 117, 237, 0.04);
                flex-direction: row;
            }
            .state_list_warp:nth-of-type(3){
                background: rgba(42, 117, 237, 0.02);
                flex-direction: row;
            }
            .state_pic_warp{
                position: absolute;
                top: 0;
                right: 0px;
                width: 689px;
                height: 360px;
                .pic_box{
                    z-index: 999;
                    width: 689px;
                    height: 360px;
                    background-size: 100% 100%;
                    background-image: url('../../../common/images/other/data_center_img@2x.png');
                    position: absolute;
                    top: 0;
                    right: 20px;
                    &>div{
                        height: auto;
                        width: 108px;
                        position: absolute;
                        &>p {
                            height: 20px;
                            line-height: 20px;
                        }
                    }
                    .fw_xdzhl_box {
                        top: 100px;
                        right: 88px;
                    }
                    .xd_fkzhl_box {
                        top: 240px;
                        right: 138px;
                    }
                    .fw_fkzhl_box {
                        bottom: 35px;
                        right: -18px;
                    }
                }
            }
            .state_pic_warp::after {
                position: absolute;
                top: 0;
                right: 0;
                content: "";
                width: 50%;
                height: 100%;
                background: rgb(255, 255, 255);
                z-index: 1;
            }
        }
        .echarts_line_warp {
            margin: 50px 0 20px 0;
            height: 430px;
        }
    }
    .trading_container2 {
        .top_warp {
            // height: 430px;
            display: flex;
            .echarts_pie_warp {
                margin-right: 55px;
                width: 40%;
                height: 430px;
            }
            .table_warp {
                margin-left: 55px;
                padding-top: 50px;
                width: 60%;
                height: 430px;
            }
        }
        .echarts_bar_warp {
            margin: 20px 0 80px 0;
            height: 360px;
        }
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>
